import { useState } from "react";
import { ImagePlay, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { isGuest } from "@/lib/guest";

const fmt = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;

// Lightbox (videos, owner or admin): pick the thumbnail frame
export const ThumbButton = ({ it, onChanged }) => {
  const [open, setOpen] = useState(false);
  const [frames, setFrames] = useState(null);
  const [busy, setBusy] = useState(false);
  if (isGuest() || !it.can_delete || it.media_type !== "video") return null;
  const toggle = async () => {
    setOpen(!open);
    if (open || frames) return;
    try { setFrames((await api.get(`/items/${it.id}/frames`)).data.frames); } catch (e) { setFrames([]); toast.error(errMsg(e)); }
  };
  const use = async (ts) => {
    setBusy(true);
    try {
      onChanged?.((await api.post(`/items/${it.id}/thumbnail`, { ts })).data);
      toast.success(`Thumbnail set at ${fmt(ts)}`);
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const useCurrent = () => {
    const v = document.querySelector("[data-testid=lightbox-video]");
    if (!v) return;
    v.pause();
    use(v.currentTime || 0);
  };
  return (
    <div className="relative">
      <button className="lb-btn" onClick={toggle} title="Set thumbnail" aria-label="Set thumbnail" data-testid="lightbox-thumbnail-button"><ImagePlay size={18} /></button>
      {open && (
        <div className="lb-menu thumb-menu" data-testid="thumbnail-menu">
          <button onClick={useCurrent} disabled={busy} data-testid="thumbnail-use-current">{busy ? <Loader2 size={14} className="animate-spin inline" /> : "Use this frame"} <span className="text-stone-500 text-xs">(pause the video first)</span></button>
          <div className="lb-menu-empty">Or pick a suggested frame</div>
          {!frames ? <div className="lb-menu-empty" data-testid="thumbnail-loading"><Loader2 size={14} className="animate-spin inline" /> Finding good frames…</div> : (
            <div className="thumb-frames">
              {frames.map((f) => (
                <button key={f.ts} onClick={() => use(f.ts)} disabled={busy} data-testid={`thumbnail-frame-${String(f.ts).replace(".", "-")}`}>
                  <img src={f.image} alt="" /><span>{fmt(f.ts)}</span>
                </button>
              ))}
              {!frames.length && <div className="lb-menu-empty">No frames available right now.</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
